import { render, staticRenderFns } from "./departlist.vue?vue&type=template&id=3d58be0e&scoped=true"
import script from "./departlist.vue?vue&type=script&lang=js"
export * from "./departlist.vue?vue&type=script&lang=js"
import style0 from "./departlist.vue?vue&type=style&index=0&id=3d58be0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d58be0e",
  null
  
)

export default component.exports